import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { patientApi } from "./ApiClient";
import type { IVideoService } from "@medoma/models/video";
import { generateQueryString } from "./Helpers";

const jitsiInfoSchema = z.object({ token: z.string(), domain: z.string() });

const videoKeys = {
  all: ["video"] as const,
  info: (patientId: string, videoService: IVideoService) =>
    [...videoKeys.all, "info", { patientId, videoService }] as const,
};

async function getVideoInfo(patientId: string, videoService: IVideoService) {
  const path = `patients/${patientId}/videocall`;
  if (videoService === "Jitsi") {
    const queryParameters = generateQueryString({
      "video-service": "jitsi",
    });
    const url = `${path}${queryParameters}`;

    return {
      ...(await patientApi.post(url).json(jitsiInfoSchema)),
      videoService: "Jitsi" as const,
    };
  }

  return null;
}

export const useVideoInfo = (
  patientId: string,
  videoService: IVideoService,
) => {
  return useQuery({
    queryKey: videoKeys.info(patientId, videoService),
    queryFn: () => getVideoInfo(patientId, videoService),
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
};
